import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
} from '@mui/material';

export default function UpdateAlertDialog({ open, onGoToProfile, onMaybeLater }) {
  const intl = useIntl();

  return (
    <Dialog open={open} maxWidth="sm" fullWidth>
      <DialogTitle sx={{ textAlign: 'center', fontWeight: 'bold' }}>
        {intl.formatMessage({ id: 'jobs.updateAlert.title' })}
      </DialogTitle>
      <DialogContent>
        <Typography variant="body1" sx={{ textAlign: 'center' }}>
          {intl.formatMessage({ id: 'jobs.updateAlert.message' })}
        </Typography>
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'center', pb: 3, gap: 2 }}>
        <Button
          variant="contained"
          onClick={onGoToProfile}
          sx={{
            backgroundColor: '#2e7d32',
            '&:hover': { backgroundColor: '#1b5e20' },
            textTransform: 'none',
            px: 3,
          }}
        >
          {intl.formatMessage({ id: 'jobs.updateAlert.goToProfile' })}
        </Button>
        <Button
          variant="contained"
          onClick={onMaybeLater}
          sx={{
            backgroundColor: '#1976d2',
            '&:hover': { backgroundColor: '#1565c0' },
            textTransform: 'none',
            px: 3,
          }}
        >
          {intl.formatMessage({ id: 'jobs.updateAlert.maybeLater' })}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

UpdateAlertDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onGoToProfile: PropTypes.func.isRequired,
  onMaybeLater: PropTypes.func.isRequired,
};
